import * as React from "react";
import { useParams } from "react-router-dom";
import HomeClient from "../../components/home/HomeClient";
import { listPropertiesPaged } from "../../api/properties";
import { normalizeLocale } from "../../utils/locales";

type RouteParams = { locale?: string };


export default function HomePage() {
  const { locale } = useParams<RouteParams>();
  const loc = normalizeLocale(locale);

  const [latest, setLatest] = React.useState<any[]>([]);
  const [hot, setHot] = React.useState<any[]>([]);
  const [sale, setSale] = React.useState<any[]>([]);
  const [loading, setLoading] = React.useState(true);

  React.useEffect(() => {
    let cancelled = false;

    (async () => {
      setLoading(true);
      try {
        const [latestRes, hotRes, saleRes] = await Promise.all([
          listPropertiesPaged({ limit: 12, offset: 0 }),
          listPropertiesPaged({ label: "Hot Offer", limit: 6, offset: 0 }),
          listPropertiesPaged({ status: "sale", limit: 6, offset: 0 }),
        ]);

        if (cancelled) return;
        setLatest(latestRes.items || []);
        setHot(hotRes.items || []);
        setSale(saleRes.items || []);
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [loc]);

  return (
    <HomeClient
      key={`home-${loc}-${latest.length}-${hot.length}-${sale.length}`}
      locale={loc}
      latest={latest}
      hot={hot}
      sale={sale}
      loading={loading}
    />
  );
}
